// Generated by purs version 0.14.4
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var AddressExtra = function (x) {
    return x;
};
var udecodeAddressExtra = Unscramble.decode_Foreign;
var newtypeAddressExtra = {
    Coercible0: function () {
        return undefined;
    }
};
var encodeAddressExtra = Foreign_Generic_Class.foreignEncode;
var eqAddressExtra = {
    eq: Data_Function.on(Data_Eq.eq(Data_Eq.eqString))(Foreign_Generic.encodeJSON(encodeAddressExtra))
};
var showAddressExtra = {
    show: (function () {
        var $0 = Data_Show.show(Data_Show.showString);
        var $1 = Foreign_Generic.encodeJSON(encodeAddressExtra);
        return function ($2) {
            return $0($1($2));
        };
    })()
};
var decodeAddressExtra = Foreign_Generic_Class.foreignDecode;
export {
    AddressExtra,
    newtypeAddressExtra,
    showAddressExtra,
    eqAddressExtra,
    decodeAddressExtra,
    udecodeAddressExtra,
    encodeAddressExtra
};
//# sourceMappingURL=index.js.map
